import e from "react";
import { useTranslation as c } from "react-i18next";
import { useBooking as a } from "../context.js";
import m from "../../../hooks/customization/useCustomization.js";
import s from "../bookingForm.module.scss.js";
function d() {
  const { t: o } = c(), {
    back: n
  } = a(), {
    getTextTranslations: i
  } = m(), t = i("booking");
  return /* @__PURE__ */ e.createElement("div", { "data-testid": "no-matching-locations-step" }, /* @__PURE__ */ e.createElement("div", { className: s.title }, /* @__PURE__ */ e.createElement("i", { onClick: () => n(), className: "lni lni-chevron-left" }), (t == null ? void 0 : t.no_match_title) || o("shopLanding.book.notMatch.title")), /* @__PURE__ */ e.createElement(
    "div",
    {
      style: {
        fontSize: "14px"
      }
    },
    (t == null ? void 0 : t.no_match_text) || o("shopLanding.book.notMatch.text")
  ));
}
export {
  d as NoMatchingLocationsStep
};
//# sourceMappingURL=NoMatchingLocationsStep.js.map
